import { Alert, Button } from "@/atoms";
import { AlertVariantEnum, ButtonVariantEnum } from "@/enums";

import { AuthHeader } from "./auth-header";

export const AuthInvalidState = ({
    actionLabel,
    message,
    onAction,
    onPrimaryAction,
    primaryActionLabel,
    title,
}: {
    actionLabel: string,
    message: string,
    onAction: () => void,
    onPrimaryAction?: () => void,
    primaryActionLabel?: string,
    title: string,
}) => (
    <div>
        <AuthHeader title={title} />
        <Alert
            className="mb-6"
            variant={AlertVariantEnum.ERROR}
        >{message}</Alert>
        {primaryActionLabel && onPrimaryAction && (
            <Button
                className="mb-3"
                onClick={onPrimaryAction}
                isFullWidth
            >{primaryActionLabel}</Button>
        )}
        <Button
            variant={ButtonVariantEnum.LINK}
            onClick={onAction}
        >{actionLabel}</Button>
    </div>
);
